<template>
  <pt-lot-list class="pt-lot-list__page"></pt-lot-list>
</template>

<script>
import PtLotList from 'cps/lab-order/pt-lot-list/withData'
export default {
  name: 'pt-lot-list__view',
  components: {
    'pt-lot-list': PtLotList
  }
}
</script>
